<template>
    <v-dialog
        :content-class="contentClass"
        :value="value"
        @input="onDialogInput"
        :persistent="isPersistent"
        :width="width"
        :max-width="maxWidth"
        :retain-focus="false"
        :transition="false"
        @keydown.esc="!isPersistent ? $emit('input', false) : null"
        @click:outside="emitCloseDialog"
        :hide-overlay="hideOverlay"
    >
        <template v-slot:activator="{ on, attrs }" style="justify-content: end !important">
            <slot name="dialog-button" v-bind:event="{ on, attrs }" />
        </template>

        <v-card class="myprovet-dialog-card" :max-height="maxHeight" :height="height" data-cy="app-dialog-card">
            <v-card-title v-if="!isAlertDialog" class="d-flex justify-space-between align-center title-text dark-blue-color mx-1 px-6" data-cy="app-dialog-title">
                {{ title }}
                <v-spacer></v-spacer>
                <v-tooltip v-bind="$attrs" bottom open-on-hover content-class="myprovet-tooltip" data-cy="edit-product-icon" v-if="isProductDetails && product_details_link">
                    <template v-slot:activator="{ on, attrs }">
                        <v-hover v-slot="{ hover }">
                            <v-btn class="elevation-2 mr-2" :class="{ 'btn-bg-color-blue': hover }" x-small fab :href="product_details_link" v-bind="attrs" v-on="on" target="_blank">
                                <v-icon>mdi-briefcase-plus</v-icon>
                            </v-btn>
                        </v-hover>
                    </template>

                    <span class="font-size-xs">{{ $t('dialogs.productEditRequest') }}</span>
                </v-tooltip>
                <v-icon class="close-icon-button btn-bg-color-blue dark-blue-color" @click="onCloseDialog" data-cy="app-dialog-close-btn"> mdi-close </v-icon>
            </v-card-title>

            <v-card-subtitle v-if="subtitle" class="font-size-sm pl-7 pt-1">
                {{ subtitle }}
            </v-card-subtitle>

            <v-card-text v-if="!isProductVideoDialog && !isPropecInfoDetails" class="px-6" :class="!showActions ? 'pb-2' : 'pb-0 pt-0'" :style="contentStyle">
                <slot name="actions" />
            </v-card-text>
            <v-card-text class="wrap-content px-6" :class="!showActions ? 'pb-2' : ''" :style="contentStyle">
                <slot name="content" />
            </v-card-text>

            <slot name="image" />
            <v-card-actions :class="!showActions ? 'pb-0' : 'pb-4'" class="px-6">
                <slot name="buttons-left" v-bind="{}"></slot>
                <v-spacer></v-spacer>
                <slot name="buttons" v-bind="{}"></slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { axios } from '@/Services/Backend';

export default {
    props: {
        value: { default: false },
        title: '',
        subtitle: { default: null },
        width: { default: '' },
        contentStyle: '',
        isPersistent: { default: false },
        maxHeight: '',
        height: { default: '' },
        maxWidth: { default: '75vw' },
        isResponsive: { default: false },
        isAlertDialog: { default: false },
        isOrderDetails: { default: false },
        isProductDetails: { default: false },
        isShoppingCartDetails: { default: false },
        isProductCampaingDetails: { default: false },
        isProductComments: { default: false },
        isConfirmationDialog:{default: false},
        isProfileDialog:{default: false},
        isUserDetails:{default: false},
        isUploadOrder:{default: false},
        isPropecInfoDetails:{ default: false },
        isCampaignPdf:{ default: false },
        isFilters: { default: false },
        isConsumptions:{ default: false },
        isMonthlyPurchases:{default: false},
        isQrcodeScannerDialog:{default:false},
        isProductVideoDialog:{default:false},
        showActions: { default: true },
        hideOverlay: { default: false },
    },

    data() {
        return {
            product_details_link: null,
        };
    },

    watch: {
        'userStore.user': {
            handler: function (user) {
                if (!user || !this.isProductDetails || !this.userStore.hasPermissionTo('See the link to change the product details')) {
                    return;
                }

                axios
                    .get('/api/products/product_details_link')
                    .then((response) => {
                        this.product_details_link = response.data;
                    })
                    .catch((error) => {
                        console.log(error?.response);
                        this.showError(this.$t('dialogs.editLinkError'));
                    });
            },
            immediate: true,
        },
    },
    methods: {
        onCloseDialog() {
            var element = document.getElementById("app");
            element.classList.remove("fix-background");
            this.$emit('input', false);
            this.emitCloseDialog();
        },

        emitCloseDialog() {
            var element = document.getElementById("app");
            element.classList.remove("fix-background");
            window.EventBus.$emit('closeDialog');
        },

        onDialogInput(isDialogOpen) {
            var element = document.getElementById("app");
            element.classList.add("fix-background");
            this.$emit('input', isDialogOpen);
        },
    },

    computed: {
        ...mapStores(useUserStore),

        contentClass() {
            let classes = '';
            if (this.isResponsive) {
                classes += ' v-dialog-responsive';
            }
            if (this.isOrderDetails) {
                classes += ' order-details-dialog';
            }
            if (this.isProductDetails) {
                classes += ' product-details-dialog';
            }
            if (this.isShoppingCartDetails) {
                classes += ' shopping-cart-dialog';
            }
            if(this.isProductCampaingDetails){
                classes += ' product-campaign-dialog'
            }
            if(this.isFilters){
                classes += ' filter-dialog'
            }
            if(this.isProductComments){
                classes += ' product-comment-dialog'
            }
            if(this.isConfirmationDialog){
                classes += ' confirmation-dialog'
            }
            if(this.isUserDetails){
                classes += ' user-details-dialog'
            }
            if(this.isUploadOrder){
                classes += ' upload-order-dialog'
            }
            if(this.isPropecInfoDetails){
                classes += ' propec-info-dialog'
            }
            if(this.isCampaignPdf){
                classes += ' campaign-pdf-dialog'
            }
            if(this.isMonthlyPurchases){
                classes += ' monthly-purchases-dialog'
            }
            if(this.isConsumptions){
                classes += ' stats-consumptions-dialog'
            }
            if(this.isQrcodeScannerDialog){
                classes += ' qrcode-scanner-dialog'
            }
            if(this.isProfileDialog){
                classes += ' profile-dialog'
            }

            return classes;
        },
    },
};
</script>

<style scoped>
.myprovet-dialog-card {
    border-radius: 16px !important;
}

.close-icon-button {
    width: 32px !important;
    min-width: 32px !important;
    max-width: 32px !important;
    height: 32px !important;
    max-height: 32px !important;
    border-radius: 8px;
}
</style>
